import { PulseModule, SharedConfigurations } from '@pulse/common';
import { sharedDefaultConfigs } from './configuration';
import { sharedProviders } from './providers';

function buildConfig(userConfig: Partial<SharedConfigurations>): SharedConfigurations {
    const config: SharedConfigurations = {
        ...sharedDefaultConfigs,
        ...userConfig,
        initialDocURL: (window as any).paa?.idu,
    };

    if (config.mode !== 'standard') {
        config.trafficSourceDetectorStorageType = 'memory';
    }

    return config;
}

export const SharedModule = new PulseModule().provide(sharedProviders).beforeInit(buildConfig);
